const isRemembered = () => localStorage.getItem('rememberMe') === 'true'

const currentStorage = () => (isRemembered() ? localStorage : sessionStorage)

export const getItemFromStorage = ({name}) => {
  const raw = currentStorage().getItem(name)
  try {
    return JSON.parse(raw)
  } catch {
    return raw
  }
}

export const setDataInStorage = ({name, data}) =>
  currentStorage().setItem(name, JSON.stringify(data))

export const removeItemFromStorage = ({name}) =>
  currentStorage().removeItem(name)
